import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import RegisteredContentAssesorsDatabase from 'features/databasePage/registered-content-assesors';

// web routing
const HomePage = Loadable(lazy(() => import('features/home')));
// const ApplicationsPage = Loadable(lazy(() => import('features/applications')));
const DatabasePage = Loadable(lazy(() => import('features/databasePage')));
const AECDatabasePage = Loadable(lazy(() => import('features/databasePage/arts')));
const FilmsDatabase = Loadable(lazy(() => import('features/databasePage/films')));
const VideoGamesDatabase = Loadable(lazy(() => import('features/databasePage/video-games')));
const ProhibitedTelcomPage = Loadable(lazy(() => import('features/databasePage/prohibited-telecom')));
const TelecomLicencePage = Loadable(lazy(() => import('features/databasePage/telecom-licence')));
const OthersLicencePage = Loadable(lazy(() => import('features/databasePage/others')));
const RegisteredImportersDatabasePage = Loadable(lazy(() => import('features/databasePage/pages/RegisteredImporters')));
const AppsPage = Loadable(lazy(() => import('features/eadvisor/application')));
const GuidePage = Loadable(lazy(() => import('features/eadvisor/pages/Guide')));
const ApplicationsPage = Loadable(lazy(() => import('features/eadvisor/pages/Applications')));
const SearchPage = Loadable(lazy(() => import('features/search')));
const TermsAndConditionsPage = Loadable(lazy(() => import('features/home/TermsAndConditions')));
const SupportedBrowserPage = Loadable(lazy(() => import('features/home/SupportedBrowser')));
const ContactUsPage = Loadable(lazy(() => import('features/home/ContactUs')));
const PrivacyStatementPage = Loadable(lazy(() => import('features/home/PrivacyStatement')));
const TelecomEquipmentPage = Loadable(lazy(() => import('features/databasePage/telecom-equipment')));
const NewspaperRegisterSearch = Loadable(lazy(() => import('features/databasePage/newspaper-register')));
const NewspaperRegisterStatus = Loadable(lazy(() => import('features/databasePage/newspaper-register/NewspaperRegisterStatus')));

// ==============================|| AUTH ROUTING ||============================== //

const HomePageRoutes = {
    path: '/',
    children: [
        {
            name: 'home',
            path: '/',
            element: <HomePage />
        },
        {
            name: 'applications',
            path: '/applications',
            element: <ApplicationsPage />
        },
        {
            name: 'guides',
            path: '/guides',
            element: <GuidePage />
        },
        {
            name: 'databases',
            path: '/databases',
            element: <DatabasePage />
        },
        {
            name: 'Guide Type',
            path: '/guide/:appID',
            element: <AppsPage />
        },
        {
            name: 'App Type',
            path: '/application/:appID',
            element: <AppsPage />
        },
        {
            name: 'search',
            path: '/search',
            element: <SearchPage />
        },
        {
            name: 'Arts Entertainment Database',
            path: '/databases/arts',
            element: <AECDatabasePage />
        },
        {
            name: 'Films Classification Database',
            path: '/databases/films',
            element: <FilmsDatabase />
        },
        {
            name: 'Video Classification Database',
            path: '/databases/video-games',
            element: <VideoGamesDatabase />
        },
        {
            name: 'Prohibited Telecommunication Equipment',
            path: '/databases/prohibited-telecommunication-equipment',
            element: <ProhibitedTelcomPage />
        },
        {
            name: 'Registered Content Assessors Database',
            path: '/databases/registered-content-assessors-database',
            element: <RegisteredContentAssesorsDatabase />
        },
        {
            name: 'Licence Search',
            path: '/databases/others',
            element: <OthersLicencePage />
        },
        {
            name: 'Licence Search',
            path: '/databases/licence-search',
            element: <TelecomLicencePage />
        },
        {
            name: 'Equipment Search',
            path: '/databases/equipment-search',
            element: <TelecomEquipmentPage />
        },
        {
            name: 'Registered Importers Database Page',
            path: '/databases/registered-importers-database-page',
            element: <RegisteredImportersDatabasePage />
        },
        {
            name: 'Newspaper Register Search',
            path: '/databases/newspaper-register-search',
            element: <NewspaperRegisterSearch />
        },
        {
            name: 'Newspaper Register Summary',
            path: '/databases/newspaper-register-confirmation',
            element: <NewspaperRegisterStatus />
        },
        {
            name: 'terms',
            path: '/Terms-of-Use',
            element: <TermsAndConditionsPage />
        },
        {
            name: 'browser',
            path: '/Supported-Browser',
            element: <SupportedBrowserPage />
        },
        {
            name: 'privacy',
            path: '/Privacy-Statement',
            element: <PrivacyStatementPage />
        },
        {
            name: 'contact-us',
            path: '/contact-us',
            element: <ContactUsPage />
        }
    ]
};

export default HomePageRoutes;
